export const REFERRAL_BLOG_POST_PAYWALL = 'blog-post-paywall';
